import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialDataList } from '@interfaces/common/common.Interface'

export interface HanhChinhState {
  taiSanList?: any
  danhMucTaiSanList?: any
  taiLieuTaiSanList?: any
  baoTriTaiSanList?: any
  muonTraTaiSanList?: any
  phongHopList?: any
  datLichHopList?: any
  thanhPhanThamDuList?: any
  reloadHanhChinhList?: string | null
}

const initialState: HanhChinhState = {
  taiSanList: initialDataList,
  danhMucTaiSanList: initialDataList,
  taiLieuTaiSanList: initialDataList,
  baoTriTaiSanList: initialDataList,
  muonTraTaiSanList: initialDataList,
  phongHopList: initialDataList,
  datLichHopList: initialDataList,
  thanhPhanThamDuList: initialDataList,
  reloadHanhChinhList: null,
}

export const hanhChinhDucks = createSlice({
  name: 'hanhChinh',
  initialState,
  reducers: {
    // Tài sản
    layDanhSachTaiSan: (state: RootState, action: PayloadAction<any>) => {
      state.taiSanList = { loading: true, queryStr: action.payload }
    },
    layDanhSachTaiSanThanhCong: (state, action: PayloadAction<any>) => {
      state.taiSanList = { loading: false, ...action.payload }
    },
    layDanhSachTaiSanThatBai: (state, action: PayloadAction<any>) => {
      state.taiSanList = { loading: false, ...action.payload }
    },

    // Danh mục tài sản
    layDanhSachDanhMucTaiSan: (state: RootState, action: PayloadAction<any>) => {
      state.danhMucTaiSanList = { loading: true, queryStr: action.payload }
    },
    layDanhSachDanhMucTaiSanThanhCong: (state, action: PayloadAction<any>) => {
      state.danhMucTaiSanList = { loading: false, ...action.payload }
    },
    layDanhSachDanhMucTaiSanThatBai: (state, action: PayloadAction<any>) => {
      state.danhMucTaiSanList = { loading: false, ...action.payload }
    },

    // Tài liệu tài sản
    layDanhSachTaiLieuTaiSan: (state: RootState, action: PayloadAction<any>) => {
      state.taiLieuTaiSanList = { loading: true, queryStr: action.payload }
    },
    layDanhSachTaiLieuTaiSanThanhCong: (state, action: PayloadAction<any>) => {
      state.taiLieuTaiSanList = { loading: false, ...action.payload }
    },
    layDanhSachTaiLieuTaiSanThatBai: (state, action: PayloadAction<any>) => {
      state.taiLieuTaiSanList = { loading: false, ...action.payload }
    },

    // Bảo trì tài sản
    layDanhSachBaoTriTaiSan: (state: RootState, action: PayloadAction<any>) => {
      state.baoTriTaiSanList = { loading: true, queryStr: action.payload }
    },
    layDanhSachBaoTriTaiSanThanhCong: (state, action: PayloadAction<any>) => {
      state.baoTriTaiSanList = { loading: false, ...action.payload }
    },
    layDanhSachBaoTriTaiSanThatBai: (state, action: PayloadAction<any>) => {
      state.baoTriTaiSanList = { loading: false, ...action.payload }
    },

    // Mượn trả tài sản
    layDanhSachMuonTraTaiSan: (state: RootState, action: PayloadAction<any>) => {
      state.muonTraTaiSanList = { loading: true, queryStr: action.payload }
    },
    layDanhSachMuonTraTaiSanThanhCong: (state, action: PayloadAction<any>) => {
      state.muonTraTaiSanList = { loading: false, ...action.payload }
    },
    layDanhSachMuonTraTaiSanThatBai: (state, action: PayloadAction<any>) => {
      state.muonTraTaiSanList = { loading: false, ...action.payload }
    },

    // Phòng họp
    layDanhSachPhongHop: (state: RootState, action: PayloadAction<any>) => {
      state.phongHopList = { loading: true, queryStr: action.payload }
    },
    layDanhSachPhongHopThanhCong: (state, action: PayloadAction<any>) => {
      state.phongHopList = { loading: false, ...action.payload }
    },
    layDanhSachPhongHopThatBai: (state, action: PayloadAction<any>) => {
      state.phongHopList = { loading: false, ...action.payload }
    },

    // Đặt lịch họp
    layDanhSachDatLichHop: (state: RootState, action: PayloadAction<any>) => {
      state.datLichHopList = { loading: true, queryStr: action.payload }
    },
    layDanhSachDatLichHopThanhCong: (state, action: PayloadAction<any>) => {
      state.datLichHopList = { loading: false, ...action.payload }
    },
    layDanhSachDatLichHopThatBai: (state, action: PayloadAction<any>) => {
      state.datLichHopList = { loading: false, ...action.payload }
    },

    // Thành phần tham dự
    layDanhSachThanhPhanThamDu: (state: RootState, action: PayloadAction<any>) => {
      state.thanhPhanThamDuList = { loading: true, queryStr: action.payload }
    },
    layDanhSachThanhPhanThamDuThanhCong: (state, action: PayloadAction<any>) => {
      state.thanhPhanThamDuList = { loading: false, ...action.payload }
    },
    layDanhSachThanhPhanThamDuThatBai: (state, action: PayloadAction<any>) => {
      state.thanhPhanThamDuList = { loading: false, ...action.payload }
    },

    datTaiLaiDanhSachHanhChinh: (state: RootState) => {
      state.reloadHanhChinhList = String(Date.now())
    },
  },
})

export const {
  layDanhSachTaiSan,
  layDanhSachTaiSanThanhCong,
  layDanhSachTaiSanThatBai,
  layDanhSachDanhMucTaiSan,
  layDanhSachDanhMucTaiSanThanhCong,
  layDanhSachDanhMucTaiSanThatBai,
  layDanhSachTaiLieuTaiSan,
  layDanhSachTaiLieuTaiSanThanhCong,
  layDanhSachTaiLieuTaiSanThatBai,
  layDanhSachBaoTriTaiSan,
  layDanhSachBaoTriTaiSanThanhCong,
  layDanhSachBaoTriTaiSanThatBai,
  layDanhSachMuonTraTaiSan,
  layDanhSachMuonTraTaiSanThanhCong,
  layDanhSachMuonTraTaiSanThatBai,
  layDanhSachPhongHop,
  layDanhSachPhongHopThanhCong,
  layDanhSachPhongHopThatBai,
  layDanhSachDatLichHop,
  layDanhSachDatLichHopThanhCong,
  layDanhSachDatLichHopThatBai,
  layDanhSachThanhPhanThamDu,
  layDanhSachThanhPhanThamDuThanhCong,
  layDanhSachThanhPhanThamDuThatBai,
  datTaiLaiDanhSachHanhChinh,
} = hanhChinhDucks.actions

export default hanhChinhDucks.reducer
